import { createSelector, } from 'reselect';
/**
 * This is the actual function that will get the data from the state and return it. However, this function return a new object every time
 * therefore we need to use memoize to create the result of this function
 */
const selectOrganizationsFunc = (orgsById, orgIds) => {
    if (orgIds) {
        return orgIds.reduce((result, orgId) => {
            const org = orgsById[orgId];
            if (org) {
                return [
                    ...result,
                    org,
                ];
            }
            return result;
        }, []);
    }
    return undefined;
};
/**
* Select ALL organizations. Technically we can use "state.organizations.orgIds" and map the orgIds in the array
* to the actual OrganizationInfo and return an array of those organizations. However, doing that will return a new array every time this function
* is called. This will cause an infinite loop in the react render component.
* So what this function does is instead of returning a new array of Organizations, it return a Function that will do just that. However, this
* Function will be memoized based on the selectOrganizationsFunc as cache key. So if this function is called multiple time but the data has not
* changed, the cached result will be returned by "createSelector".
*/
export const selectAllOrganizations = createSelector((state) => { return state.organizations.orgsById; }, (state) => { return state.organizations.orgIds; }, selectOrganizationsFunc);
export const selectOrganizationById = (state, orgId) => {
    return state.organizations.orgsById[orgId];
};
export const selectOrganizationByBaseUrl = (state, baseUrl) => {
    return state.organizations.orgsByBaseUrl[baseUrl];
};
